import {useCallback, useEffect, useRef} from 'react';
import {debounce} from 'lodash';

import {useTranslation} from '/provider/TranslationProvider';

export const useSearchHeader = ({
  searchInput,
  updateSearchInput,
  hasSearchResults,
  fetchSearchResults,
  recordsParams,
}: any) => {
  const {ts} = useTranslation('screen.search');
  const filterRef = useRef(recordsParams);

  const onInputChange = useCallback(debounce(fetchSearchResults, 500), []);

  useEffect(() => {
    if (searchInput.length < 3) {
      return;
    }
    if (!hasSearchResults || filterRef.current !== recordsParams) {
      onInputChange({searchInput, recordsParams});
      filterRef.current = recordsParams;
    }
  }, [searchInput, recordsParams]);

  const onChangeText = (value: any) => updateSearchInput({searchInput: value});
  const onClear = () => updateSearchInput({searchInput: ''});

  return {ts, onChangeText, onClear};
};
